// extracted by mini-css-extract-plugin
export default {"wrapper":"CJR9O"};